angular.module('cfn').component('greeningMainCrop', {
  bindings: {
    chartDataMainCrop: '<',
    greeningResults: '<',
    totalArea: '<',
    leavesArea: '<',
    cerealArea: '<',
    isSecondFruit: '<',
    plannedFruits: '<'
  },
  controller: GreeningMainCropController,
  controllerAs: 'vm',
  templateUrl: require('./greeningMainCrop.html')
});

GreeningMainCropController.$inject = ['userSettingsService'];
function GreeningMainCropController(userSettingsService) {
  var vm = this;
  vm.areaUnitSymbol = userSettingsService.getAreaUnit();
}
